
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class UserSkills extends Vue {
  @Prop(Object) user!: any;
  @Prop(Number) index!: any;
  @Prop(Array) optionTool!: any;
  @Prop(Array) optionsStatus!: any;
  @Prop(Function) saveSkill!: any;
  @Prop(Function) cancelButton!: any;
  skillError = [];

  mounted() {
    this.loadSkill();
  }

  @Watch("user.language")
  changeLang() {
    if (typeof this.user.oi_conocimiento !== "object") {
      this.loadSkill();
    }
  }

  loadSkill() {
    if (this.user.c_nivel) {
      this.user.c_nivel = this.optionsStatus.find(
        (i: any) => i.code === this.user.c_nivel
      );
    }
    if (this.user.oi_conocimiento) {
      this.user.oi_conocimiento = this.optionTool.find((i: any) => {
        return i.external_id === parseInt(this.user.oi_conocimiento);
      });
    }
  }

  validateSkill() {
    this.skillError = [];
    if ((this as any).user.oi_conocimiento && (this as any).user.c_nivel) {
      this.saveSkill();
    }
    else {
      if (!(this as any).user.oi_conocimiento) {
        (this as any).skillError.push('skill');
      }
      if (!(this as any).user.c_nivel) {
        (this as any).skillError.push('tool');
      }
    }
  }

  handleSelect(event: any, type: string) {
    if (!event) {
      if (type === 'tool') {
        (this as any).user.oi_conocimiento = null;
      }
      else {
        (this as any).user.c_nivel = null;
      }
    }
  }
}
